import React, { Component } from 'react';

import Scheduler, {
  SchedulerData,
  ViewTypes,
  DATE_FORMAT,
  CellUnits,
} from 'scheduler-react/lib';
import 'scheduler-react/lib/css/style.css';
import moment from 'moment';
import { emitAgentCommand } from '../../../onboardingAgent';
import { summarizeIssue } from '../../../onboardingAgent/productContext';
import withDragDropContext from './withDnDContext';

class CalendarScheduler extends Component {
  constructor(props) {
    super(props);
    const { project } = this.props;
    const projectName = project.label;
    const Url = project.url;
    const projectImg = project.avatar;

    const schedulerData = new SchedulerData(
      // eslint-disable-next-line new-cap
      new moment().format(DATE_FORMAT),
      ViewTypes.Custom1,
      false,
      false,
      {
        customCellWidth: '7%',
        nonAgendaDayCellHeaderFormat: 'M/D|HH:mm',
        views: [
          {
            viewName: 'Week',
            viewType: ViewTypes.Week,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: 'Two weeks',
            viewType: ViewTypes.Custom1,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: 'Month',
            viewType: ViewTypes.Month,
            showAgenda: false,
            isEventPerspective: false,
          },
        ],
        project: projectName,
        projectUrl: Url,
        projectImage: projectImg,
      },
      {
        getCustomDateFunc: this.getCustomDate,
        isNonWorkingTimeFunc: this.isNonWorkingTime,
      },
    );
    schedulerData.localeMoment.locale('en');

    this.state = {
      viewModel: schedulerData,
    };
  }

  render() {
    const { viewModel } = this.state;
    const { events, resources } = this.props;

    const schedulerData = this.state.viewModel;
    schedulerData.setResources(resources);
    schedulerData.setEvents(events);

    return (
      <div>
        <Scheduler
          schedulerData={viewModel}
          prevClick={this.prevClick}
          nextClick={this.nextClick}
          onSelectDate={this.onSelectDate}
          onViewChange={this.onViewChange}
          updateEventStart={this.updateEventStart}
          updateEventEnd={this.updateEventEnd}
          moveEvent={this.moveEvent}
          eventItemPopoverTemplateResolver={
            this.eventItemPopoverTemplateResolver
          }
          toggleExpandFunc={this.toggleExpandFunc}
        />
      </div>
    );
  }

  refreshEvents = (schedulerData) => {
    const { events } = this.props;
    schedulerData.setEvents(events || []);
    this.setState({
      viewModel: schedulerData,
    });
  };

  prevClick = (schedulerData) => {
    schedulerData.prev();
    this.refreshEvents(schedulerData);
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective,
    );
    this.refreshEvents(schedulerData);
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    this.refreshEvents(schedulerData);
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    this.refreshEvents(schedulerData);
  };

  persistDueDate = async (schedulerData, event, newEnd, applyLocal) => {
    const { persistEventChange } = this.props;
    if (!persistEventChange) {
      return false;
    }

    const dueLabel = moment(newEnd).format('LL');
    // eslint-disable-next-line no-alert
    const confirmed = window.confirm(
      `Update GitLab due date for "${event.title}" to ${dueLabel}?`,
    );
    if (!confirmed) {
      return false;
    }

    try {
      await persistEventChange({ event, newEnd });
      applyLocal();
      this.setState({ viewModel: schedulerData });
      emitAgentCommand('schedule_updated', {
        eventItem: event,
        newEnd,
      });
      return true;
    } catch (error) {
      // eslint-disable-next-line no-alert
      window.alert(
        `Could not update GitLab issue: ${error?.message || 'unknown error'}`,
      );
      return false;
    }
  };

  updateEventStart = (schedulerData, event, newStart) => {
    // GitLab issues expose due_date, not a first-class start date.
    // Keep start edits local-only so created_at history stays intact.
    // eslint-disable-next-line no-alert
    const confirmed = window.confirm(
      `Move local start for "${event.title}"? This does not write to GitLab.`,
    );
    if (!confirmed) {
      return;
    }
    schedulerData.updateEventStart(event, newStart);
    this.setState({
      viewModel: schedulerData,
    });
  };

  updateEventEnd = async (schedulerData, event, newEnd) => {
    await this.persistDueDate(schedulerData, event, newEnd, () => {
      schedulerData.updateEventEnd(event, newEnd);
    });
  };

  moveEvent = async (schedulerData, event, slotId, slotName, start, end) => {
    if (String(slotId) !== String(event.resourceId)) {
      // eslint-disable-next-line no-alert
      window.alert(
        'Rows are issues, not people. Use Ask guide to reassign an assignee in GitLab.',
      );
      return;
    }

    await this.persistDueDate(schedulerData, event, end, () => {
      schedulerData.moveEvent(event, slotId, slotName, start, end);
    });
  };

  eventItemPopoverTemplateResolver = (
    schedulerData,
    eventItem,
    title,
    start,
    end,
    statusColor,
  ) => {
    const summary = summarizeIssue({
      ...eventItem,
      title,
      start: start && start.toISOString ? start.toISOString() : eventItem.start,
      end: end && end.toISOString ? end.toISOString() : eventItem.end,
    });

    return (
      <React.Fragment>
        <div style={{ maxWidth: 280, padding: '4px 2px' }}>
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: statusColor,
              display: 'inline-block',
              marginRight: 8,
            }}
          />
          <h3 style={{ margin: '8px 0', display: 'inline' }}>{title}</h3>
          <div style={{ marginTop: 8 }}>
            <span style={{ fontWeight: 'bold' }}>Assignee: </span>
            {eventItem.author || 'No Assignee'}
          </div>
          {eventItem.label && (
            <div>
              <span style={{ fontWeight: 'bold' }}>Label: </span>
              {eventItem.label}
            </div>
          )}
          {eventItem.img && (
            <div style={{ textAlign: 'center', margin: '10px' }}>
              <img
                alt={eventItem.author || title}
                style={{ width: 64, height: 64, borderRadius: '7em' }}
                src={eventItem.img}
              />
            </div>
          )}
          <h5 style={{ marginTop: 10, textAlign: 'center' }}>
            {start.format('LL')} - {end.format('LL')}
          </h5>
          <p style={{ fontSize: 12, color: '#555', marginTop: 8 }}>{summary}</p>
          <button
            type="button"
            style={{
              width: '100%',
              marginTop: 8,
              border: 'none',
              borderRadius: 8,
              padding: '8px 10px',
              background: '#F08421',
              color: '#fff',
              fontWeight: 600,
              cursor: 'pointer',
            }}
            onClick={() => {
              emitAgentCommand('ask_about_issue', {
                eventItem: {
                  ...eventItem,
                  title,
                  start: eventItem.start,
                  end: eventItem.end,
                },
              });
            }}
          >
            Ask guide
          </button>
        </div>
      </React.Fragment>
    );
  };

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({
      viewModel: schedulerData,
    });
  };

  getCustomDate = (schedulerData, num, date = undefined) => {
    const { viewType } = schedulerData;
    let selectDate = schedulerData.startDate;
    if (date !== undefined) {
      selectDate = date;
    }

    let startDate =
      num === 0 ?
        selectDate :
        schedulerData
          .localeMoment(selectDate)
          .add(2 * num, 'days')
          .format(DATE_FORMAT);
    let endDate = schedulerData
      .localeMoment(startDate)
      .add(1, 'days')
      .format(DATE_FORMAT);
    let cellUnit = CellUnits.Hour;
    if (viewType === ViewTypes.Custom1) {
      const monday = schedulerData
        .localeMoment(selectDate)
        .startOf('week')
        .format(DATE_FORMAT);
      startDate =
        num === 0 ?
          monday :
          schedulerData
            .localeMoment(monday)
            .add(2 * num, 'weeks')
            .format(DATE_FORMAT);
      endDate = schedulerData
        .localeMoment(startDate)
        .add(1, 'weeks')
        .endOf('week')
        .format(DATE_FORMAT);
      cellUnit = CellUnits.Day;
    } else if (viewType === ViewTypes.Custom2) {
      const firstDayOfMonth = schedulerData
        .localeMoment(selectDate)
        .startOf('month')
        .format(DATE_FORMAT);
      startDate =
        num === 0 ?
          firstDayOfMonth :
          schedulerData
            .localeMoment(firstDayOfMonth)
            .add(2 * num, 'months')
            .format(DATE_FORMAT);
      endDate = schedulerData
        .localeMoment(startDate)
        .add(1, 'months')
        .endOf('month')
        .format(DATE_FORMAT);
      cellUnit = CellUnits.Day;
    }

    return {
      startDate,
      endDate,
      cellUnit,
    };
  };

  isNonWorkingTime = (schedulerData, time) => {
    const { localeMoment } = schedulerData;
    if (schedulerData.cellUnit === CellUnits.Hour) {
      const hour = localeMoment(time).hour();
      if (hour < 1) {
        return true;
      }
    } else {
      const dayOfWeek = localeMoment(time).weekday();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        return true;
      }
    }

    return false;
  };
}

export default withDragDropContext(CalendarScheduler);
